import React from 'react';
import {useWindowSize} from "@uidotdev/usehooks";
import {Flex} from "antd";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import MyText from "../../components/UI/Text/MyText";
import Header from "../components/Header/Header";
import {clrs} from "../../constants/colors";
import {Fade} from "react-awesome-reveal";
import {CaretRightOutlined} from "@ant-design/icons";
import Footer from "../components/Footer/Footer";

const InstructionForEngMath = () => {
    const size = useWindowSize();

    return (
        <div>
            <Header/>
            <Flex style={{width: "100%", position: "relative", padding: "140px 20px 120px 20px"}} align={"center"}
                  justify={"center"}>
                <Flex gap={50} style={{width: "100%", maxWidth: 1440, position: "relative"}} vertical
                      align={"flex-start"} justify={"flex-start"}>
                    {/*<NewBanner/>*/}
                    <Flex gap={80} style={{width: "100%", maxWidth: 1440, position: "relative"}} vertical
                          align={"flex-start"} justify={"flex-start"}>
                        <Flex
                            align={"center"}
                            justify={"center"}
                            style={{width: "100%", padding: 30, backgroundColor: clrs.blackerBlue, borderRadius: 20}}
                            vertical>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText stronger uppercase
                                        style={{fontSize: "1.2rem", color: clrs.white, textAlign: "center"}}>
                                    <IntlMessage id={'insEngMath.title'}/>
                                </MyText>
                            </Fade>

                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"center"} vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                {/*<MyText size={"larger"} strong>*/}
                                {/*    Foundation Astana IT University*/}
                                {/*</MyText>*/}
                                <MyText uppercase style={{textAlign: "justify", fontSize: "1.2rem", color: "red"}}>
                                    <IntlMessage id={'insEngMath.isForPayAbitur'}/>
                                </MyText>
                            </Fade>

                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText size={size.width > 800 ? "larger" : "large"} strong>
                                    <IntlMessage id={'insEngMath.sec-1.title'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <IntlMessage id={'insEngMath.sec-1.step-1'}/> <a
                                    href={"https://cce.astanait.edu.kz/"} target="_blank">ССЫЛКА</a>
                                </MyText>
                                <Flex vertical gap={"small"} align={"flex-start"} justify={"center"}>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-2'}/>
                                    </MyText>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem", marginLeft: "2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-2.title'}/>
                                    </MyText>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem", marginLeft: "2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-2.text-1'}/>
                                    </MyText>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem", marginLeft: "2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-2.text-2'}/>
                                    </MyText>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem", marginLeft: "2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-2.text-3'}/>
                                    </MyText>
                                </Flex>
                                <Flex vertical gap={"small"} align={"flex-start"} justify={"center"}>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-3'}/>
                                    </MyText>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem", marginLeft: "2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-3.text-1'}/>
                                    </MyText>
                                </Flex>
                                <Flex vertical gap={"small"} align={"flex-start"} justify={"center"}>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-4'}/>
                                    </MyText>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem", marginLeft: "2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-4.text-1'}/>
                                    </MyText>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem", marginLeft: "2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-4.text-2'}/>
                                    </MyText>
                                    <MyText style={{textAlign: "justify", fontSize: "1.2rem", marginLeft: "2rem"}}>
                                        <IntlMessage id={'insEngMath.sec-1.step-4.text-3'}/>
                                    </MyText>
                                </Flex>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <IntlMessage id={'insEngMath.sec-1.step-5'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <IntlMessage id={'insEngMath.sec-1.step-6'}/>
                                </MyText>
                            </Fade>
                        </Flex>

                        {/*<Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"} vertical gap={20}>*/}
                        {/*    <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>*/}
                        {/*        <MyText size={size.width > 800 ? "larger" : "large"} strong>*/}
                        {/*            <IntlMessage id={'foundationPage.aboutCourse'}/>*/}
                        {/*        </MyText>*/}
                        {/*        <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>*/}
                        {/*            <CaretRightOutlined style={{color: clrs.yellow}}/>*/}
                        {/*            <IntlMessage id={'foundationPage.aboutCourse.1'}/>*/}
                        {/*        </MyText>*/}
                        {/*        <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>*/}
                        {/*            <CaretRightOutlined style={{color: clrs.yellow}}/>*/}
                        {/*            <IntlMessage id={'foundationPage.aboutCourse.2'}/>*/}
                        {/*        </MyText>*/}
                        {/*        <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>*/}
                        {/*            <CaretRightOutlined style={{color: clrs.yellow}}/>*/}
                        {/*            <IntlMessage id={'foundationPage.aboutCourse.3'}/>*/}
                        {/*        </MyText>*/}
                        {/*        <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>*/}
                        {/*            <CaretRightOutlined style={{color: clrs.yellow}}/>*/}
                        {/*            <IntlMessage id={'foundationPage.aboutCourse.4'}/>*/}
                        {/*        </MyText>*/}
                        {/*    </Fade>*/}
                        {/*</Flex>*/}
                        {
                            size.width > 940 ?
                                <Flex style={{width: "100%", position: "relative"}} align={"flex-start"}
                                      justify={"center"} vertical>
                                    <Flex style={{width: "100%", height: 400, position: "relative",}}>
                                        <Flex style={{
                                            width: "50vw",
                                            position: "absolute",
                                            height: 400,
                                            backgroundColor: clrs.yellow, left: "calc(0px - (100vw - 100%) / 2)",
                                            paddingLeft: "calc((100vw - 100%) / 2)",
                                            paddingRight: 20,
                                            paddingTop: 50,
                                            paddingBottom: 50
                                        }} vertical gap={20}>
                                            <Fade triggerOnce={true} cascade damping={0.15} direction={"left"}>
                                                <MyText size={"bigger"} strong>
                                                    <IntlMessage id={'insEngMath.sec-2.one.title'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.one.text-1'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.one.text-2'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.one.text-3'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.one.text-4'}/>
                                                </MyText>
                                            </Fade>

                                        </Flex>
                                        <Flex
                                            style={{
                                                width: "50vw",
                                                position: "absolute",
                                                height: 400,
                                                backgroundColor: clrs.blackerBlue,
                                                left: "calc(0px - (100vw - 100%) / 2 - 2.5px + 50vw)",
                                                paddingLeft: 50,
                                                paddingRight: "calc((100vw - 100%) / 2)",
                                                paddingTop: 50,
                                                paddingBottom: 50,
                                                color: "white"
                                            }} vertical gap={20}>
                                            <Fade triggerOnce={true} cascade damping={0.15} direction={"right"}>
                                                <MyText size={"bigger"} strong>
                                                    <IntlMessage id={'insEngMath.sec-2.two.title'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.two.text-1'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.two.text-2'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.two.text-3'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.two.text-4'}/>
                                                </MyText>
                                            </Fade>

                                        </Flex>
                                    </Flex>
                                </Flex>
                                :
                                <Flex style={{width: "100%", position: "relative"}} align={"flex-start"}
                                      justify={"center"} vertical>
                                    <Flex style={{width: "100%", position: "relative",}} vertical align={"center"}
                                          justify={"center"}>
                                        <Flex style={{
                                            width: "100%",
                                            position: "relative",
                                            height: 400,
                                            backgroundColor: clrs.yellow,
                                            paddingLeft: 50,
                                            paddingRight: 20,
                                            paddingTop: 50,
                                            paddingBottom: 50
                                        }} vertical gap={20}>
                                            <Fade triggerOnce={true} cascade damping={0.15} direction={"left"}>
                                                <MyText size={"bigger"} strong>
                                                    <IntlMessage id={'insEngMath.sec-2.one.title'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.one.text-1'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.one.text-2'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.one.text-3'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.one.text-4'}/>
                                                </MyText>
                                            </Fade>

                                        </Flex>
                                        <Flex
                                            style={{
                                                width: "100%",
                                                position: "relative",
                                                height: 400,
                                                backgroundColor: clrs.blackerBlue,
                                                paddingLeft: 50,
                                                paddingRight: 50,
                                                paddingTop: 50,
                                                paddingBottom: 50,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 20,
                                                color: "white"
                                            }} vertical gap={20}>
                                            <Fade triggerOnce={true} cascade damping={0.15} direction={"right"}>
                                                <MyText size={"bigger"} strong>
                                                    <IntlMessage id={'insEngMath.sec-2.two.title'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.two.text-1'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.two.text-2'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.two.text-3'}/>
                                                </MyText>
                                                <MyText>
                                                    <IntlMessage id={'insEngMath.sec-2.two.text-4'}/>
                                                </MyText>
                                            </Fade>

                                        </Flex>
                                    </Flex>
                                </Flex>
                        }

                        <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"center"} vertical
                              gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                {/*<MyText size={"larger"} strong>*/}
                                {/*    Foundation Astana IT University*/}
                                {/*</MyText>*/}
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <IntlMessage id={'insEngMath.sec-3.title'}/>
                                </MyText>
                            </Fade>

                        </Flex>


                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText size={size.width > 800 ? "larger" : "large"} strong>
                                    <IntlMessage id={'insEngMath.sec-4.title'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-4.text-1'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-4.text-2'}/>
                                </MyText>
                            </Fade>
                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText size={size.width > 800 ? "larger" : "large"} strong>
                                    <IntlMessage id={'insEngMath.sec-5.title'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-5.text-1'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-5.text-2'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-5.text-3'}/>
                                </MyText>
                            </Fade>
                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"center"} vertical
                              gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                {/*<MyText size={"larger"} strong>*/}
                                {/*    Foundation Astana IT University*/}
                                {/*</MyText>*/}
                                <MyText strong size={size.width > 800 ? "x-large" : "large"}
                                        style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <IntlMessage id={'insEngMath.sec-7.title'}/>
                                </MyText>
                            </Fade>
                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText size={size.width > 800 ? "larger" : "large"} strong>
                                    <IntlMessage id={'insEngMath.sec-6.title'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-6.text-1'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-6.text-2'}/>
                                </MyText>
                            </Fade>
                        </Flex>

                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText size={size.width > 800 ? "larger" : "large"} strong>
                                    <IntlMessage id={'insEngMath.sec-8.title'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-8.text-1'}/>
                                </MyText>
                                <MyText style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <CaretRightOutlined style={{color: clrs.yellow}}/>
                                    <IntlMessage id={'insEngMath.sec-8.text-2'}/>
                                </MyText>
                                <MyText style={{textAlign: "center", fontSize: "1.2rem"}}>
                                    <IntlMessage id={'insEngMath.sec-8.text-3'}/>
                                </MyText>
                            </Fade>
                        </Flex>

                        <Flex
                            gap={30}
                            align={"flex-start"}
                            justify={"center"}
                            style={{
                                width: "100%",
                                border: "1px solid #D7D7D7",
                                borderRadius: 20,
                                padding: "30px 15px"
                            }}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <Flex gap={10} vertical align={"center"} justify={"center"}>
                                    <MyText strong size={"large"}
                                            style={{color: clrs.blackerBlue, textAlign: "center"}}>
                                        <IntlMessage id={'insEngMath.sec-9.title'}/>
                                    </MyText>
                                    <MyText size={"bigger"} style={{color: clrs.whiterBlacker, textAlign: "center"}}>
                                        <IntlMessage id={'insEngMath.sec-9.text'}/> : 87172645710
                                    </MyText>

                                </Flex>
                            </Fade>

                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"center"} vertical
                              gap={"small"}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                {/*<MyText size={"larger"} strong>*/}
                                {/*    Foundation Astana IT University*/}
                                {/*</MyText>*/}
                                <MyText strong size={size.width > 800 ? "x-large" : "large"}
                                        style={{textAlign: "justify", fontSize: "1.2rem"}}>
                                    <IntlMessage id={'insEngMath.sec-10.title'}/>
                                </MyText>
                                <MyText italic style={{maxWidth: 500, fontWeight: 400}}>
                                    <IntlMessage id={'insEngMath.sec-10.text'}/>
                                </MyText>
                            </Fade>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
            <Footer/>
        </div>
    );
};

export default InstructionForEngMath;